import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MapPin, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const Cities = () => {
  const [cities, setCities] = useState([]);
  useEffect(() => { api.get("/cities").then((r) => setCities(r.data)); }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <Navbar />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-20">
        <p className="text-[10px] uppercase tracking-widest font-bold text-[#2D7FF9] font-mono-num">— CITIES</p>
        <h1 className="font-display font-extrabold text-5xl md:text-6xl mt-4 tracking-tight">Ride across India.</h1>
        <p className="text-gray-600 mt-4 max-w-xl text-lg">Available in 6 metropolitan cities with 50+ pickup points and counting.</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {cities.map((c, i) => (
            <Link key={c.slug} to={`/bikes?city=${c.slug}`} data-testid={`city-link-${c.slug}`} className="group relative aspect-[4/5] rounded-3xl overflow-hidden card-premium !p-0">
              <img src={c.image} alt={c.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-6 text-white">
                <p className="text-[10px] uppercase tracking-widest font-mono-num opacity-80">0{i + 1}</p>
                <h3 className="font-display font-extrabold text-4xl mt-2 tracking-tight">{c.name}</h3>
                <div className="flex items-center gap-2 mt-3 text-sm opacity-90">
                  <MapPin size={14} />{c.pickup_points?.length || 0} pickup points
                  <ArrowUpRight className="ml-auto group-hover:rotate-45 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Cities;
